import { render } from "./ProjectTest.vue?vue&type=template&id=6f3cd7ce&scoped=true"
import script from "./ProjectTest.vue?vue&type=script&lang=js"
export * from "./ProjectTest.vue?vue&type=script&lang=js"

import "./ProjectTest.vue?vue&type=style&index=0&id=6f3cd7ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3cd7ce"]])

export default __exports__